import { Type } from '@angular/core';

/**
 * Registry dei dialoghi disponibili per l'apertura tramite URL
 * La chiave è l'ID usato nell'URL, il valore è il componente da aprire
 */
export const DIALOG_REGISTRY: Record<string, Type<any>> = {
};

/**
 * Funzione per registrare un nuovo componente dialog nel registry
 * @param id Identificatore univoco del dialog (da usare nell'URL)
 * @param component Componente del dialog da registrare
 */
export function registerDialog(id: string, component: Type<any>): void {
  if (DIALOG_REGISTRY[id]) {
    console.warn(`Un dialog con ID '${id}' è già registrato e verrà sovrascritto`);
  }
  DIALOG_REGISTRY[id] = component;
}

/**
 * Funzione per controllare se un dialog è registrato
 * @param id Identificatore del dialog da verificare
 * @returns true se il dialog è registrato, false altrimenti
 */
export function isDialogRegistered(id: string): boolean {
  return DIALOG_REGISTRY[id] !== undefined;
} 